module.exports = __webpack_public_path__ + "static/media/icon-upload.bb54fe2a.svg";